import Bouncer from 'components/Common/Bouncer';
import React from 'react';
import { HButton } from 'BaseComponents';
import { Link, useHistory, useParams } from 'react-router-dom';
import { cleanRoom } from 'utils/spaUrls';
import { cleanRoomPermissions } from 'utils/appConstants';
import { updateSelectedFlow } from 'redux/actions/FlowAction';
import { useDispatch } from 'react-redux';


const FlowDatasetsManagement = ({ flowDetails }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { crId } = useParams();
  const onClickManageDatasets = () => {
    dispatch(updateSelectedFlow({ flowID: flowDetails.flow.ID }));
    history.push(cleanRoom.flowManageDatasets(crId, flowDetails.ID));
  };

  if (!flowDetails) {
    return null;
  }

  return (
    <>
      <Bouncer allowList={[
        cleanRoomPermissions.crFlowsBuilder,
        cleanRoomPermissions.manageDatasets,
      ]}
      >
        <HButton
          size='small'
          data-testid='flow-management-dataset-button'
          component={Link}
          to='#'
          onClick={onClickManageDatasets}
          variant='outlined'
        >
          Assign Datasets
        </HButton>
      </Bouncer>
    </>
  );
};


export default FlowDatasetsManagement;
